declare var window: any;

window.removeHTMLTags = function (html: string): string | void {
  if (html) {
    html = html.replace(/&(lt|gt);/g, function (strMatch: string, p1) {
      return p1 == 'lt' ? '<' : '>';
    });
    return html.replace(/<\/?[^>]+(>|$)/g, '');
  }
};
window.tinyMCE.overrideDefaults({
  base_url: '/assets/tinymce/', // Base for assets such as skins, themes and plugins
  suffix: '.min', // This will make Tiny load minified versions of all its assets
});

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
